<template>
    <section class="withdraw-wrappwer">
        <div class="container">
            <div class="withdraw-sec deposit_module mt-0">
                <div class="back-modal">
                    <div class="withdawForm-group">
                        <div class="withdrawalForm-group">
                            <label><span>{{ $t('withdraw', 'Withdraw') }}</span></label>
                            <label>available balance: <span>{{ withdrawlBalance || 0 }}</span></label>
                        </div>
                        <input v-model="withdrawAmount" class="form-control profit-input" type="number" placeholder="Enter amount" 
                        @input="withdrawAmount = $helper.sanitizeNumber(+withdrawAmount, +walletConfig?.withdrawal_range?.max || 99999999)"/>
                        <span class="error-messages-text" v-if="v$.withdrawAmount.$error">{{$t('please-enter-amount','Please Enter Amount')}}</span>
                        <div class="online-form-int">
                            <label class="form-check-label gray-color">({{$t('min-amount','Min amount')}}:  {{ walletConfig?.withdrawal_range.min || 100  }})</label>
                        </div>
                    </div>

                    <div class="thm-gradient-but deposit-amount-bx stake-button" v-if="walletConfig?.stake_button">
                        <ul>
                            <li v-for="(stake, index) in (userTransactionStakes ? [...userTransactionStakes] : walletConfig?.stake_button)" :key="index">
                                <a @click="setStakeValue(stake)">
                                    <span class="btn-thm heigh-btn">
                                        +{{ stake }}
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <!-- <div class="withdraw-btn">
                        <a href="#" class="stakeedit-anchore thm-but" data-bs-toggle="modal" data-bs-target="#editModal">
                            <span><img src="assets/images/edit-icon.svg" class="editimg" alt="edit-icon" loading="lazy" /></span> Edit
                            Stake   
                        </a>
                    </div> -->
                    <div class="withdraw-fix-sec continue-btn">
                        <a href="#walleteditstackModal" data-bs-toggle="modal" class="editStake-btn">
                            <span><img loading="lazy" src="@/assets/images/edit-icon.svg" alt="edit-icon"></span>
                            <span>{{$t('edit-stake', 'Edit Stake')}}</span>
                        </a>
                        <a href="javascript:void(0);" class="thm-but" id="account-successfully" data-bs-toggle="modal" data-bs-target="#instructionsModal">{{ $t('proceed', 'Proceed') }}</a>
                    </div>
                    <div class="mt-1">
                        <p class="text-center">-or-</p>
                        <div class="withdraw-btn deposit-btn">
                            <router-link :to="{name: 'WalletDeposit'}" class="wantbtn thm-but"> {{$t('want-to-deposit','Want to Deposit')}} ?</router-link>
                        </div>
                        <div class="forgotWithdraw-wrap">
                            <a href="javascript:void(0)" class="forgot--btn" @click="forgetWithdrawModal()">
                                <i class="fa-solid fa-lock"></i>
                                {{$t('forgot-withdraw-password','Forgot Withdraw Password')}}?
                            </a> 
                        </div>
                    </div>
                    <TutorialVideo type = "3"/>
                </div>
            </div>
            <WalletInstructionVideos/>
        </div>
    </section>
    <WithdrawPasswordModal ref="withdrawSetReset"
        :triggerAddAccountMethod="triggerAddAccountMethod" />
    <WalletInstructionsModal instructionType="withdrawal" :actionMethod="withdrawAmountClick"/>
    <WalletStakeModal ref="resetStakeCall" @updateStakes="getStakes" v-if="walletConfig" :stakes="walletConfig?.stake_button" />
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import {withdrawAmountClickValidation,openWithdrawPasswordModal} from '@template/utils'
import WalletInstructionsModal from '../components/WalletInstructionsModal.vue';
import WalletInstructionVideos from '../components/WalletInstructionVideos.vue';
import WalletStakeModal from '../components/WalletStakeModal.vue';
import TutorialVideo from '../components/TutorialVideo.vue';
import WithdrawPasswordModal from '../components/WithdrawPasswordModal.vue';
export default {
    name: "WalletWithdraw",
    setup() {
        return { v$: useVuelidate() }
    },
    inject: ['walletConfig', 'getStakes'],
    components: {
        WalletInstructionsModal,
        WalletInstructionVideos,
        WithdrawPasswordModal,
        WalletStakeModal,
          TutorialVideo
    },
    computed: {
        ...mapGetters([
            'globalLoader', 'userTransactionStakes'
        ]),
        withdrawlBalance() {
            let { balance = 0, expl = 0 } = this.$auth?.user || {};
            let earnBonus = this.$store.getters?.user?.earnBonus || 0;
            return (parseFloat(balance) + parseFloat(expl || 0) - parseFloat(earnBonus)).toFixed(2);
        }
    },
    data(){
        return{
            withdrawAmount: null,
        }
    },
    validations: {
        withdrawAmount: { required}
    },
    methods:{
        setStakeValue(stake) {
            this.withdrawAmount += parseFloat(stake);
            if(this.withdrawAmount > this.walletConfig?.withdrawal_range?.max){
                this.withdrawAmount = this.walletConfig?.withdrawal_range?.max;
            }
        },
        async withdrawAmountClick(){
            this.v$.$touch()
            if (this.v$.$error) {
                console.log(this.v$.$error)
                return
            }else{ 
                let response = await withdrawAmountClickValidation(this.withdrawAmount, this.walletConfig, this.withdrawlBalance)
                if(response){
                    this.goToWithdrawAccount()
                }
            }
        },
        forgetWithdrawModal(){
            this.openWithdrawPasswordModal()
        },
        triggerAddAccountMethod(){
            this.addAccount();
        },
        async addAccount(){
            this.v$.$touch();
			if (this.v$.$error) {
				// this.$errorToast('Please fill the required fields');
				return;
			}
            if(this.type === 'upi' && !this.upiDetails.upi_id && this.upiDetails.qr_code == null){
                this.$errorToast('At least one field is required UPI ID or QR code.')
                return false;
            }
            let response = await addAccount(this.paymentMethod, this.type, this.bankDetails, this.upiDetails)
            if(response){
                this.$router.push({
                    name:'WithdrawDetails'
                })
            }
        },
        async openWithdrawPasswordModal(){
            let response = await openWithdrawPasswordModal()
            if(!response?.error){
                this.$helper.openModal('#newUserWithDrawPasswordModel');
                this.$refs.withdrawSetReset.otpHasBeenCalled()
                this.$refs.withdrawSetReset.resetTimer();
            }else{
                // this.addAccount();
                this.$errorToast(response?.error);
            }

        },
        goToWithdrawAccount() {
            this.$store.dispatch('setWithdrawAmount', this.withdrawAmount);
            this.$router.push({ name: 'WithdrawDetails' })
        },
    }
}
</script>

<style scoped>
.wth-bal {
    background: var(--primary-color);
}
.withdraw-btn{
    margin-top: 0px;
}
</style>